/**
 * builtin-skills.ts — Client-side helpers around the skill list.
 *
 * The canonical skill list (including prompt bodies) lives in the BE
 * SkillRegistryService. The UI fetches metadata via GET /skills on init
 * and stores it in RuntimeState.skills. This file just provides helpers
 * that operate on that list.
 */

import type { SkillMeta } from "./types";

/**
 * Fuzzy filter by id, name.vi, name.en (case-insensitive substring match).
 * Returns the full list when query is empty.
 */
export function filterSkills(skills: SkillMeta[], query: string): SkillMeta[] {
  const q = query.trim().toLowerCase();
  if (!q) return skills;
  return skills.filter((s) => {
    const haystack = `${s.id} ${s.name.vi} ${s.name.en}`.toLowerCase();
    return haystack.includes(q);
  });
}

export function getSkillById(
  skills: SkillMeta[],
  id: string,
): SkillMeta | undefined {
  return skills.find((s) => s.id === id);
}
